<script>
    import { spotTypes, startYears } from "./Constants";
    import {
        rank,
        grade,
        spotMargin,
        spotTypeBeforeAPICall,
        startYear,
        userHasPremium,
    } from "./Stores";
    import { Tooltip, Button } from "flowbite-svelte";

    export let handleSubmit;

    function yearIsPremium(year) {
        return year < 2020;
    }
</script>

<form
    class="flex flex-col items-center outline outline-neutral-100 p-3 mb-3 mt-2 rounded-md"
    on:submit={handleSubmit}
>
    {#if $spotTypeBeforeAPICall === spotTypes.IFE}
        <div>
            <label for="inputData">O teu lugar no ranking:</label>
            <input
                class=" py-0.1 ml-1 w-20 rounded-md text-black text-center"
                type="number"
                min="0"
                id="inputData"
                cy_data="ife_form_ranking_input"
                bind:value={$rank}
            />
        </div>
        <div class="mt-2">
            <label for="inputData"
                >Margem de vagas
                <Button id="info">&#9432</Button>
                :
            </label>
            <input
                class=" py-0.1 ml-1 w-20 rounded-md text-black text-center"
                type="number"
                min="0"
                id="inputData"
                cy_data="ife_form_margin_input"
                bind:value={$spotMargin}
            />
        </div>
        <div class="mt-2">
            <label for="start_year">Ano de começo:</label>
            <select
                class=" py-0.1 ml-1 w-20 rounded-md text-black text-center"
                id="start_year"
                bind:value={$startYear}
            >
                {#each startYears as year}
                    <option
                        disabled={!$userHasPremium && yearIsPremium(year)}
                        value={year}
                    >
                        {year}
                        {!$userHasPremium && yearIsPremium(year)
                            ? "(premium)"
                            : ""}
                    </option>
                {/each}
            </select>
        </div>
        <Tooltip
            triggeredBy="#info"
            trigger="click"
            class="bg-slate-600 rounded-md max-w-xs text-center"
        >
            <p>
                A margem representa o número de lugares acima do teu para os
                quais queres que mostremos as vagas ocupadas.
            </p>
            <p>
                Ex: se a tua posição for 500 e a margem for 50, vamos mostrar as
                vagas a partir da posição 450.
            </p>
            <p>
                As vagas dentro da margem não contam para o número de vagas
                disponíveis e aparecem a cinzento, para não te confundires :)
            </p>
        </Tooltip>
    {:else}
        <div>
            <label for="inputData">A tua média ponderada:</label>
            <input
                class=" py-0.1 ml-1 w-20 rounded-md text-black text-center"
                type="number"
                min="0"
                id="inputData"
                placeholder="0"
                bind:value={$grade}
            />
        </div>
    {/if}

    <button
        class=" mt-2 px-3 py-1 bg-cyan-950 rounded-md outline-gray-800 text-center hover:text-neutral-300 active:bg-cyan-800"
        type="submit"
        cy_data="submit"
    >
        Submeter
    </button>
</form>

<style>
    div {
        display: flex;
        justify-content: end;
        width: 100%;
        gap: 5pt;
    }

    /* Hide the arrows on the number input field */
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    option:disabled {
        color: #666;
    }
</style>
